var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feather-icon',{staticClass:"mr-2 play-icon",attrs:{"icon":"PlayCircleIcon"},on:{"click":_vm.play}}),_c('audio',{ref:"player",staticStyle:{"display":"none"},attrs:{"preload":"metadata","src":_vm.src,"controls":""},on:{"loadedmetadata":_vm.setMax}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }